import block from './block.json';

export const cardCalendarThemeAttributes = {
	padding: {
		top: [25, 35],
		bottom: [25, 30],
	},
	label: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.text-xxs',
		textAlignment: 'left',
	},
	artist: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.heading-5',
		textAlignment: 'left',
	},
	title: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.fresco-xs',
		textAlignment: 'left',
	},
	time: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.small-text',
		textAlignment: 'left',
	},
	location: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.small-text',
		textAlignment: 'left',
	},
	availability: {
		label: {
			color: '@tokens.variants.default.contentColor',
			typography: '@tokens.typographies.caption',
			textAlignment: 'left',
		},
		backgroundColor: {
			high: '@tokens.colors.available.value',
			low: '@tokens.colors.brand-tertiary-base.value',
			none: '@tokens.colors.warning.value',
			soon: '@tokens.colors.neutral-200.value',
		},
	},
	date: {
		digit: {
			color: '@tokens.variants.default.contentColor',
			typography: '@tokens.typographies.introduction',
			textAlignment: 'left',
		},
		weekday: {
			color: '@tokens.variants.default.contentColor',
			typography: '@tokens.typographies.caption',
			textAlignment: 'left',
		},
	},
	states: {},
};

export const CardCalendarThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardCalendarThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
